import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHouse, faFileLines, faUser, 
    faMapLocationDot, faBoxesStacked, faFont, faBug, faListCheck,
    faCamera, faUserPen, faCopyright, faCalendarDay, faPeopleGroup, 
    faLayerGroup, faBuildingColumns 
} from '@fortawesome/free-solid-svg-icons';
import RequireRoles from '../RequireRoles';
import ReportsModal from '../ReportsModal';
import { useState } from 'react';

export default function Sidebar() {
    const location = useLocation();
    const [mostrarReportsModal, setMostrarReportsModal] = useState(false);
    
    // Verifica se estamos no contexto do Acervo Iconográfico
    const isIconografico = location.pathname.includes('/admin/iconografico');

    const NavItem = ({ path, icon, name, funcoes = null }) => {
        const isActive = location.pathname === path;
        return (
            <RequireRoles allowedRoles={funcoes}>
                <li className="nav-item">
                    <Link to={path} className={`nav-link-custom ${isActive ? "active" : ""}`}>
                        <div className="icon-box">
                            <FontAwesomeIcon icon={icon} />
                        </div>
                        <span className="nav-text">{name}</span>
                    </Link>
                </li>
            </RequireRoles>
        );
    }

    return (
        <>
            <div className="sidebar-inner">
                <nav className="sidebar-nav">
                    {/* GRUPO 1: NAVEGAÇÃO FIXA */}
                    <div className="menu-group">
                        <span className="menu-label">Navegação</span>
                        <ul className="nav-list">
                            <NavItem path="/" icon={faHouse} name="Página do Museu" />
                        </ul>
                    </div>

                    {/* GRUPO 2: CONTEXTO DINÂMICO (Troca entre Itens e Iconografia) */}
                    {isIconografico ? (
                        <>
                            {/* ACERVO ICONOGRÁFICO */}
                            <div className="menu-group animate-in">
                                <span className="menu-label text-teal">Gestão Iconográfica</span>
                                <ul className="nav-list">
                                    <NavItem path="/admin/iconografico/fotografias" icon={faCamera} name="Fotografias" />
                                    <NavItem path="/admin/iconografico/inventarios" icon={faFileLines} name="Inventários" />
                                </ul>
                            </div>

                            <div className="menu-group animate-in">
                                <span className="menu-label text-teal">Apoio à Documentação</span>
                                <ul className="nav-list">
                                    <NavItem path="/admin/iconografico/autores" icon={faUserPen} name="Autores/Fotógrafos" />
                                    <NavItem path="/admin/iconografico/pessoas" icon={faPeopleGroup} name="Pessoas Retratadas" />
                                    <NavItem path="/admin/iconografico/eventos" icon={faCalendarDay} name="Eventos" />
                                    <NavItem path="/admin/iconografico/acervos" icon={faBuildingColumns} name="Acervos" />
                                </ul>
                            </div>

                            <div className="menu-group animate-in">
                                <span className="menu-label text-teal">Auxiliares Técnicos</span>
                                <ul className="nav-list">
                                    <NavItem path="/admin/iconografico/categorias" icon={faLayerGroup} name="Categorias/Subs" />
                                    <NavItem path="/admin/iconografico/termos" icon={faFont} name="Termos" />
                                    <NavItem path="/admin/iconografico/direitos" icon={faCopyright} name="Direitos Autorais" />
                                </ul>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* ACERVO DE EQUIPAMENTOS */}
                            <div className="menu-group animate-in">
                                <span className="menu-label">Gestão de Acervo</span>
                                <ul className="nav-list">
                                    <NavItem path="/admin/itens" icon={faListCheck} name="Itens do Acervo" />
                                    <NavItem path="/admin/inventarios" icon={faFileLines} name="Inventários" />
                                </ul>
                            </div>

                            <div className="menu-group animate-in">
                                <span className="menu-label">Auxiliares Técnicos</span>
                                <ul className="nav-list">
                                    <NavItem path="/admin/termos" icon={faFont} name="Termos" />
                                    <NavItem path="/admin/categorias" icon={faBoxesStacked} name="Categorias" />
                                </ul>
                            </div>
                        </>
                    )}

                    {/* GRUPO 3: ADMINISTRAÇÃO GLOBAL (Comum para ambos os acervos) */}
                    <div className="menu-group border-top mt-2 pt-2">
                        <span className="menu-label">Administração Global</span>
                        <ul className="nav-list">
                            <NavItem path="/admin/localizacoes" icon={faMapLocationDot} name="Localização" />
                            <NavItem path="/admin/usuarios" icon={faUser} name="Usuários" funcoes={['Desenvolvedor', 'Administrador']} />
                        </ul>
                    </div>
                </nav>

                <div className="sidebar-footer">
                    <button onClick={() => setMostrarReportsModal(true)} className="btn-report-error">
                        <FontAwesomeIcon icon={faBug} className="me-2" />
                        <span>Reportar erro</span>
                    </button>
                </div>
            </div>

            <ReportsModal
                mostrarModal={mostrarReportsModal}
                fecharModal={() => setMostrarReportsModal(false)}
            />
        </>
    )
}